var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.79514 17.5C7.38275 18.0186 8.15462 18.3333 9 18.3333C9.84537 18.3333 10.6172 18.0186 11.2048 17.5M14 6.66666C14 5.34057 13.4732 4.0688 12.5355 3.13112C11.5978 2.19344 10.3261 1.66666 9 1.66666C7.67391 1.66666 6.40214 2.19344 5.46446 3.13112C4.52678 4.0688 4 5.34057 4 6.66666C4 9.24181 3.35039 11.005 2.62472 12.1712C2.0126 13.1549 1.70654 13.6467 1.71777 13.784C1.73019 13.9359 1.76238 13.9938 1.88481 14.0846C1.99538 14.1667 2.49382 14.1667 3.49071 14.1667H14.5093C15.5062 14.1667 16.0046 14.1667 16.1152 14.0846C16.2376 13.9938 16.2698 13.9359 16.2822 13.784C16.2934 13.6467 15.9874 13.1549 15.3753 12.1712C14.6496 11.005 14 9.24181 14 6.66666Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.a21ac4943aa6d0482e6f05af583739c3.svg";
export { ForwardRef as ReactComponent };